import {VatRateType} from '@dms/api/shared';

export const DEFAULT_VAT_RATE: VatRateType = 'S';
